var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1962 0H6.36987C5.88398 0 5.44412 0.267598 5.24328 0.684448L2.76205 5.83333H2.47692C1.10898 5.83333 0 6.87795 0 8.16667V14H1.90161C2.20208 12.0211 4.0086 10.5 6.19231 10.5C8.37602 10.5 10.1825 12.0211 10.483 14H26.6708C26.9713 12.0211 28.7778 10.5 30.9615 10.5C33.1453 10.5 34.9518 12.0211 35.2522 14H37.1538V10.5H36.5627L35.5357 7.45915C35.2086 6.49086 34.254 5.83333 33.1753 5.83333H30.897C28.7469 4.01597 23.5082 0 19.1962 0ZM14.8615 5.83333H7.43077V2.33333H14.8615V5.83333ZM27.2462 5.83333H17.3385V2.33333H18.2907C19.3033 2.33333 20.3156 2.44043 21.2759 2.74335C22.0835 2.99813 23.0753 3.35929 23.8404 3.79167C25.3885 4.66667 27.2462 5.83333 27.2462 5.83333Z",
    fill: "#C0BFC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/Body.b1f62c658a84132e1966497747d32727.svg";
export { ForwardRef as ReactComponent };